import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useNavigate, useParams } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Card, CardBody, CardTitle } from 'reactstrap';

const UpdateItinerary = () => {
  const { id } = useParams();
  const [locations, setLocations] = useState([]);
  const [packages, setPackages] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState('');
  const [selectedPackage, setSelectedPackage] = useState('');
  const [date, setDate] = useState('');
  const [description, setDescription] = useState('');
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const response = await api.get('/locations');
        setLocations(response.data);
      } catch (error) {
        console.error('Error fetching locations:', error);
        alert('Failed to fetch locations');
      }
    };

    const fetchPackages = async () => {
      try {
        const response = await api.get('/cards');
        setPackages(response.data);
      } catch (error) {
        console.error('Error fetching packages:', error);
        alert('Failed to fetch packages');
      }
    };

    const fetchItinerary = async () => {
      try {
        const response = await api.get(`/itineraries/${id}`);
        const itinerary = response.data;
        setSelectedLocation(itinerary.location.id);
        setSelectedPackage(itinerary.card.id);
        setDate(itinerary.date.split('T')[0]);
        setDescription(itinerary.description);
      } catch (error) {
        console.error('Error fetching itinerary:', error);
        alert('Error fetching itinerary details');
      }
    };

    fetchLocations();
    fetchPackages();
    fetchItinerary();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = {};

    if (!selectedPackage) errors.selectedPackage = 'Select a package';
    if (!selectedLocation) errors.selectedLocation = 'Select a location';
    if (!date.trim()) errors.date = 'Date cannot be empty';
    const isDescriptionEmpty = description.replace(/<(.|\n)*?>/g, '').trim() === '';
    if (isDescriptionEmpty) errors.description = 'Description cannot be empty';

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    setErrors({});

    const formData = new FormData();
    formData.append('locationId', selectedLocation);
    formData.append('cardId', selectedPackage);
    formData.append('date', date);
    formData.append('description', description);

    try {
      const response = await api.put(`/itineraries/${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.status === 200) {
        alert('Itinerary updated successfully!');
        navigate('/manage-itinerary');
      } else {
        alert('Failed to update itinerary');
      }
    } catch (error) {
      console.error('Error updating itinerary:', error);
      alert('Error updating itinerary');
    }
  };

  const handleCancel = () => {
    navigate('/manage-itinerary');
  };

  return (
    <div className='container mt-3 mb-5'>
      <CardTitle tag='h5' className='mb-3'>
        Itinerary List <span style={{ color: '#B0B0B0' }}>/ Edit Itinerary</span>
      </CardTitle>
      <Card>
        <CardBody>
          <form onSubmit={handleSubmit}>
            <div className="col-xl-8">
              <div className='mb-3'>
                <label className='form-label'>Select Package *</label>
                <select
                  className={`form-control ${errors.selectedPackage ? 'is-invalid' : ''}`}
                  value={selectedPackage}
                  onChange={(e) => setSelectedPackage(e.target.value)}
                >
                  <option value="">Select Package</option>
                  {packages.map((pkg) => (
                    <option key={pkg.id} value={pkg.id}>
                      {pkg.category.name}-{pkg.vendor.name}
                    </option>
                  ))}
                </select>
                <b>{errors.selectedPackage && <span className='text-danger small'>{errors.selectedPackage}</span>}</b>
              </div>

              <div className='mb-3'>
                <label className='form-label'>Select Location *</label>
                <select
                  className={`form-control ${errors.selectedLocation ? 'is-invalid' : ''}`}
                  value={selectedLocation}
                  onChange={(e) => setSelectedLocation(e.target.value)}
                >
                  <option value="">Select Location</option>
                  {locations.map((location) => (
                    <option key={location.id} value={location.id}>
                      {location.location}
                    </option>
                  ))}
                </select>
                <b>{errors.selectedLocation && <span className='text-danger small'>{errors.selectedLocation}</span>}</b>
              </div>

              <div className='mb-3'>
                <label className='form-label'>Date *</label>
                <input
                  type="text"
                  className={`form-control ${errors.date ? 'is-invalid' : ''}`}
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  placeholder="DD-MM-YYYY"
                />
                <b>{errors.date && <span className='text-danger small'>{errors.date}</span>}</b>
              </div>

              <div className='mb-3'>
                <label className='form-label'>Description *</label>
                <ReactQuill
                  className={`${errors.description ? 'is-invalid' : ''}`}
                  value={description}
                  onChange={setDescription}
                  placeholder="Enter Description"
                />
                <b>{errors.description && <span className='text-danger small'>{errors.description}</span>}</b>
              </div>

              <div className="button-group">
                <button type="submit" className="btn btn-success submit-button">
                  Update
                </button>
                <button type="button" className="btn btn-danger cancel-button" onClick={handleCancel}>
                  Cancel
                </button>
              </div>
            </div>
          </form>
        </CardBody>
      </Card>
    </div>
  );
};

export default UpdateItinerary;
